export default __webpack_public_path__ + "static/media/latam.518fba7f.svg";